/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import { AppConsumer } from '@keystone/common';
import { OperatorConsumer } from '../pages/operator/OperatorContext';
import { CustomerSiteConsumer } from './CustomerSiteContext';
import { UserConsumer } from '../pages/user/UserContext';
import { DeviceInfoConsumer } from '../pages/deviceinfo/DeviceInfoContext';
import { SiteConsumer } from '../pages/site/SiteContext';
import { DeviceLogsConsumer } from '../pages/devicelogs/DeviceLogsContext';

export function withApplicationContext(Component) {
  return (props) => (
    <AppConsumer>{(appContext) => <Component {...props} appContext={appContext} />}</AppConsumer>
  );
}

export function withCustomerSiteContext(Component) {
  return (props) => (
    <CustomerSiteConsumer>
      {(custSiteContext) => <Component {...props} custSiteContext={custSiteContext} />}
    </CustomerSiteConsumer>
  );
}

export function withUserContext(Component) {
  return (props) => (
    <UserConsumer>
      {(userContext) => <Component {...props} userContext={userContext} />}
    </UserConsumer>
  );
}

export function withOperatorContext(Component) {
  return (props) => (
    <OperatorConsumer>
      {(operatorContext) => <Component {...props} operatorContext={operatorContext} />}
    </OperatorConsumer>
  );
}

export function withDeviceInfoContext(Component) {
  return (props) => (
    <DeviceInfoConsumer>
      {(deviceInfoContext) => <Component {...props} deviceInfoContext={deviceInfoContext} />}
    </DeviceInfoConsumer>
  );
}

export function withSiteContext(Component) {
  return (props) => (
    <SiteConsumer>
      {(siteContext) => <Component {...props} siteContext={siteContext} />}
    </SiteConsumer>
  );
}

export function withDeviceLogsContext(Component) {
  return (props) => (
    <DeviceLogsConsumer>
      {(deviceLogsContext) => <Component {...props} deviceLogsContext={deviceLogsContext} />}
    </DeviceLogsConsumer>
  );
}
